import styled, { css, keyframes } from 'styled-components';

import { COLORS, ZINDEX } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

import Button from '../Button';

export const OPENING_ANIMATION_DURATION = 250; // ms

const TOP_POSITION_MODAL = 110;

const MODAL_SIZES = {
  small: '500px',
  medium: '800px',
  large: '1100px',
  full: '100%',
};

const isFullSize = (size: ModalSizes) => size === 'full';

export type ModalSizes = keyof typeof MODAL_SIZES;

const openAnimation = keyframes`
  0% {
        opacity: 0;
        transform: scale(0);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;

  z-index: ${ZINDEX.modalOverlay};
  background: ${COLORS.LAYER_OVERLAY};
`;

export const Container = styled.div<{
  size: ModalSizes;
}>`
  position: fixed;
  z-index: ${ZINDEX.modalContainer};
  inset: 0;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  ${({ size }) => css`
    padding: ${isFullSize(size) ? 0 : '0 5px'};
    ${media.S` padding: ${isFullSize(size) ? 0 : '0 15px'}; `}
  `}
`;

export const InnerContainer = styled.div<{
  size: ModalSizes;
  skipAnimation?: boolean;
  visualViewportHeight?: number;
}>`
  position: relative;

  ${({ size }) => css`
    top: ${isFullSize(size) ? 0 : '5%'};
    max-width: ${MODAL_SIZES[size]};
    height: ${isFullSize(size) ? '100%' : null};
    border-radius: ${isFullSize(size) ? 0 : 4}px;
    margin-bottom: ${isFullSize(size) ? 0 : 'calc(env(safe-area-inset-bottom, 0) + 50px)'};

    ${media.XL` top: ${isFullSize(size) ? 0 : `${TOP_POSITION_MODAL}px`}; `};
  `}

  padding: 16px;

  ${media.XL`
    padding: 40px;
  `};

  width: 100%;
  z-index: ${ZINDEX.modalInnerContainer};
  background: ${COLORS.NEUTRAL_WHITE};

  animation-name: ${({ skipAnimation }) => (skipAnimation ? 'none' : openAnimation)};
  animation-duration: ${OPENING_ANIMATION_DURATION}ms;
  animation-timing-function: ease-in-out;

  ${({ visualViewportHeight }) => {
    if (!visualViewportHeight) return '';
    // trick to allow the scroll on account managment modal for IOS
    return css`
      margin-bottom: ${visualViewportHeight / 2}px;
      ${Container} {
        height: 100%;
      }
    `;
  }};
`;

export const BackButton = styled(Button)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  &,
  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;

export const CloseButton = styled(Button)<{ $fixed: boolean }>`
  position: absolute !important;
  right: ${({ $fixed }) => ($fixed ? '5px' : 0)};
  top: ${({ $fixed }) => ($fixed ? '5px' : 0)};
  z-index: 1;
  background-color: ${COLORS.NEUTRAL_WHITE};
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  margin-top: 32px;
`;
